import { render, staticRenderFns } from "./bet-recap.vue?vue&type=template&id=77c8cc45"
import script from "./bet-recap.vue?vue&type=script&lang=js"
export * from "./bet-recap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c8cc45')) {
      api.createRecord('77c8cc45', component.options)
    } else {
      api.reload('77c8cc45', component.options)
    }
    module.hot.accept("./bet-recap.vue?vue&type=template&id=77c8cc45", function () {
      api.rerender('77c8cc45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/bet-recap.vue"
export default component.exports